// Nav Toggle (Global)
// ================================================
$(".mobile-nav-toggle").on("click", function () {
    $(this).toggleClass("active");
    $("body").addClass("mobile-no-scroll");
    $(".overlay").addClass("active");
    $(".header").addClass("active");
    $(".header__left nav.mobile-nav").slideToggle(300);
    $(".product-search").hide();
    $("#header-search-toggle").removeClass('active');

    if (!$(this).hasClass("active")) {
        $(".overlay").removeClass("active");
        $(".header").removeClass("active");
        $("body").removeClass("mobile-no-scroll");
    }
});

// Search Toggle (Global)
// ========================================
$("#header-search-toggle").on("click", function (e) {
    $(this).toggleClass("active");
    e.preventDefault();
    if ($("#header-search-toggle").hasClass("active")) {
        $(".product-search").slideDown(200);
    }
    $(".overlay").addClass("active");
    $("#product-search-field-0").focus();
    $(".header__left nav.mobile-nav").slideUp(300);
    $(".mobile-nav-toggle").removeClass('active');

    if (!$(this).hasClass("active")) {
        $(".overlay").removeClass("active");
        $(".header").find(".product-search").slideUp(200);
    }
});


$("#menu-header-menu-left")
    .find("li")
    .on("mouseover", () => {
        if ($("#header-search-toggle").hasClass("active")) {
            $("#header-search-toggle").removeClass("active");
            $(".overlay").removeClass("active");
        }
    });

if (!$(document).hasClass("active")) {
    $(document).on("click", ".overlay", function () {
        if ($("#header-search-toggle").hasClass("active")) {
            $(".product-search").slideUp(200);
            $("#header-search-toggle").removeClass("active");
        }
        $("body").removeClass("mini-cart--open");
        $(".overlay").removeClass("active");
    });
}

$(document).on("click", ".overlay", function () {
    $(".header").find(".product-search").slideUp(200);
    $("body").removeClass("mini-cart--open");
    $(".overlay").removeClass("active");

    // To do: Only necessary on mobile
    $(".mobile-nav-toggle").removeClass("active");
    $(".header__left nav.mobile-nav").slideUp(300);
    $("body").removeClass("mobile-no-scroll");
});

// Functions to open and close the Mini Cart
// ========================================
function closeMiniCart() {
    $(".overlay").removeClass("active");
    $("body").removeClass("mini-cart--open");
}

function openMiniCart() {
    $(document.body).trigger('wc_fragment_refresh');
    $(".overlay").addClass("active");
    $("body").addClass("mini-cart--open");
}

// Header Mobile Nav Accordion
// ========================================
/* $(".header__left .menu > li").on("click", function (e) {
    if ($(window).width() <= 991) {
        var menu = $(this).children(".sub-menu-wrap");
        $(".sub-menu-wrap").not(menu).slideUp(200);
        $(".header__left .menu > li").not(this).removeClass("sub-menu--open");
        menu.slideToggle(200);
        $(this).toggleClass("sub-menu--open")
    }
}); */

// Header Navbar Responsive
// ========================================
const itemsMenu = document.querySelectorAll(
    "#mobile-menu > li:not(.podcast, .glossary, .reward)"
);
let mobileInit = false;
let desktopInit = false;


const mobile = () => {
    itemsMenu.forEach((m) => {
        m.classList.remove('sub-menu--open');
        m.querySelector('a').classList.add('none-event');
    });
    if (mobileInit) return;
    mobileInit = true;

    itemsMenu.forEach((menu) => {
        menu.addEventListener("mouseup", function (e) {
            e.preventDefault();
            const link = this.querySelector('a');

            if (this.classList.contains('sub-menu--open')) {
                this.classList.remove('sub-menu--open');
                link.classList.add('none-event');
            } else {
                itemsMenu.forEach((m) => {
                    m.classList.remove('sub-menu--open');
                    m.querySelector('a').classList.add('none-event');
                });
                this.classList.add('sub-menu--open');
                link.classList.remove('none-event');
            }
        });

        const subMenuLinks = menu.querySelectorAll('.sub-menu-title-link');
        subMenuLinks.forEach((sublink) => {
            sublink.addEventListener("mouseup", function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (this.classList.contains('sub-menu-active')) {
                    sublink.nextElementSibling.classList.remove('sub-menu-active');
                    this.classList.remove('sub-menu-active');
                } else {
                    sublink.nextElementSibling.classList.add('sub-menu-active');
                    this.classList.add('sub-menu-active');
                }
            })
        });
    });
};

const onResize = () => {

    if (window.innerWidth <= 991) {
        mobile();
    } else {
        if ($(".mobile-nav-toggle").hasClass("active")) {
            $(".mobile-nav-toggle").trigger("click");
        }
        // Header Desktop Nav
        // ========================================
        $(document).find(".sub-menu-wrap").css({ display: 'none' });
        if (desktopInit) return;
        $(".header__left .menu:not(#mobile-menu) > li").mouseenter(function () {
            $(this).find(".sub-menu-wrap").fadeIn('fast');
            $(".product-search").hide();
        }).mouseleave(function () {
            $(this).find(".sub-menu-wrap").fadeOut('fast');
        });
        desktopInit = true;
    }

};

window.addEventListener('resize', onResize);
onResize();